<template>
  <div class="wrap_address">
    <div>
      <h4 class="title-color">Company Information</h4>
    </div>
    <div class="e-card-separator"></div>
    <div class="form-row">
      <div class="form-row-input" style="width: 1310px">
        <!-- <ejs-dropdownlist
          id="searchCompanyName"
          ref="searchCompanyName"
          placeholder="Search Company"
          :allowFiltering="true"
          filterType="Contains"
          :dataSource="companies"
          sortOrder="Ascending"
          float-label-type="Always"
          @change="onCompanySelection"
          :showClearButton="true"
          :fields="companyFields"
          cssClass="e-static-clear"
        /> -->
        <ejs-autocomplete
                ref="searchCompanyName"
                id="searchCompanyName"
                :dataSource='companies'
                placeholder="Search Company"
                :fields="companyFields"
                sortOrder="Ascending"
                filterType="Contains"
                float-label-type="Always"
                @change="onCompanySelection"
                width = "100%"
                v-model="companyDetailsInfo"
            >
          </ejs-autocomplete>
      </div>
    </div>
    <div class="form-row">
      <div style="width: 650px" class="form-row-input">
        <ejs-textbox
          name="companyName"
          float-label-type="Always"
          placeholder="Company Name"
          v-model="data.legalName"
        >
        </ejs-textbox>
      </div>
    </div>
    <div class="form-row">
      <div style="width: 650px" class="form-row-input">
        <ejs-autocomplete
          name="companyAddress"
          :dataSource="comAdressAutocompleteData"
          placeholder="Company Address"
          :fields="comAdressAutocompleteFields"
          ref="comAdressAutocomplete"
          :minLength="comAdressAutocompleteMinLength"
          :filtering="onComAddressAutocompleteFiltering"
          :change="onComAddressSelection"
          float-label-type="Always"
          v-model="data.address"
        >
        </ejs-autocomplete>
      </div>
      <div style="width: 650px" class="form-row-input">
        <ejs-textbox
          name="companyAddressLine2"
          float-label-type="Always"
          :multiline="false"
          placeholder="Company Address Line2"
          v-model="data.addressLine2"
        >
        </ejs-textbox>
      </div>
    </div>
    <div class="form-row">
      <div style="width: 650px" class="form-row-input">
        <ejs-textbox
          name="companyCityName"
          float-label-type="Always"
          placeholder="City"
          v-model="data.cityName"
        >
        </ejs-textbox>
      </div>
      <div style="width: 650px" class="form-row-input">
        <ejs-dropdownlist
          id="companyProvince"
          ref="companyProvince"
          placeholder="Province/State"
          sortOrder="Ascending"
          :allowFiltering="allowFiltering"
          :filtering="filtering"
          :dataSource="province"
          float-label-type="Always"
          v-model="companyProvince"
          :fields="companyProvinceFields"
        >
        </ejs-dropdownlist>
      </div>
    </div>
    <div class="form-row">
      <div style="width: 650px" class="form-row-input">
        <ejs-textbox
          name="default"
          float-label-type="Always"
          placeholder="Postal/Zip Code"
          v-model="data.postalCode"
          :maxlength="10"
        >
        </ejs-textbox>
      </div>
      <div style="width: 650px" class="form-row-input">
        <ejs-dropdownlist
          float-label-type="Always"
          id="companyCountry"
          ref="companyCountry"
          :dataSource="companyCountries"
          v-model="data.countryName"
          :fields="companyCountriesFields"
          placeholder="Country"
        ></ejs-dropdownlist>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import {
  DropDownListPlugin,
  AutoCompletePlugin,
} from '@syncfusion/ej2-vue-dropdowns';
import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { Query } from '@syncfusion/ej2-data';

import {
  GET_COUNTRIES,
  GET_PROVINCES,
  GET_COMPANIES,
  COMPANY_DATA,
  GET_MELISSA_ADDRESSES,
  GET_USER_COMAPNY_DATA_BY_ID,
} from '../store';

Vue.use(DropDownListPlugin);
Vue.use(TextBoxPlugin);
Vue.use(AutoCompletePlugin);

export default {
  name: 'CompanyInfo',
  props: {
    userProfileId: String,
    userProfilesData: Object,
  },
  components: {
    // SccInputValidator,
  },
  mounted() {
    this.getCountries();
    this.getCompanies();
    this.getComAddresses();
    this.companyCountries = this.$store.getters.countries;
    this.province = this.$store.getters.provinces;
    if (this.province === null) {
      this.getProvinces();
    }
    if (this.$store.getters.loggedUser !== null) this.getUserComapyDatabyId();
  },
  data() {
    return {
      companyCountries: [],
      companyCountriesFields: { text: 'countryName', value: 'countryName' },
      province: [],
      companyProvinceFields: {
        text: 'provinceName',
        value: 'provinceName',
        groupBy: 'countryName',
      },
      companies: [],
      companyFields: { value: 'text' },
      allowFiltering: true,
      companyProvince: '',
      companyId: null,
      data: {
        legalName: '',
        phoneNumber: null,
        faxNumber: null,
        address: '',
        addressLine2: '',
        cityName: '',
        postalCode: '',
        provinceName: '',
        countryName: '',
        username: null,
        source: null,
        sourceCompanyId: null,
        userId: null,
      },
      companyDetailsInfo: null,
      comAdressAutocompleteData: [],
      comAdressAutocompleteMinLength: 3,
      comAdressAutocompleteFields: { value: 'Address.Address' },
      comMelissaAddress1: '',
      comMelissaLocality: 'Edmonton',
      comMelissaAdministrativearea: 'Alberta',
      comMelissaCountry: 'CA',
      comMelissaCountryName: 'Canada',
      userProfileData: null,
      isCompanyValid: true,
    };
  },
  methods: {
    async getCountries() {
      try {
        await this.$store.dispatch(GET_COUNTRIES);
        this.companyCountries = this.$store.getters.countries;
      } catch (err) {
        console.error(err);
      }
    },
    async getProvinces() {
      try {
        await this.$store.dispatch(GET_PROVINCES);
        this.province = this.$store.getters.provinces;
      } catch (err) {
        console.error(err);
      }
    },
    async getCompanies() {
      try {
        await this.$store.dispatch(GET_COMPANIES);
        this.companies = this.$store.getters.companies;
        const mapCompanies = [].concat(
          this.companies.map((c) => ({
            id: c.companyId,
            text: c.text,
            companyId: c.companyId,
            legalName: c.legalName,
            phoneNumber: c.phoneNumber,
            faxNumber: c.faxNumber,
            address: c.address,
            addressLine2: c.addressLine2,
            cityName: c.cityName,
            postalCode: c.postalCode,
            provinceName: c.provinceName,
            countryName: c.countryName,
            source: c.source,
            sourceCompanyId: c.sourceCompanyId,
          })),
        );
        this.companies = mapCompanies;
      } catch (err) {
        console.error(err);
      }
    },
    async getUserComapyDatabyId() {
      try {
        const userId = this.userProfileId;
        await this.$store.dispatch(GET_USER_COMAPNY_DATA_BY_ID, { userId });
        if (this.$store.getters.userCompanyDatabyID !== null) {
          this.data = this.$store.getters.userCompanyDatabyID;
          this.companyProvince = this.data.provinceName;
          this.companyDetailsInfo = this.data.text;
        }
      } catch (err) {
        console.error(err);
      }
    },
    companyNameFiltering(args) {
      const searchCompanyName = this.companies;
      let query = new Query();
      // frame the query based on search string with filter type.
      query = args.text !== ''
        ? query.where('text', 'startswith', args.text, true)
        : query;
      // pass the filter data source, filter query to updateData method.
      args.updateData(searchCompanyName, query);
    },
    filtering(e) {
      const searchData = this.province;
      let query = new Query();
      // frame the query based on search string with filter type.
      query = e.text !== ''
        ? query.where('provinceName', 'startswith', e.text, true)
        : query;
      // pass the filter data source, filter query to updateData method.
      e.updateData(searchData, query);
    },
    onCompanySelection(e) {
      if (e.e) {
        const { itemData } = e;
        if (itemData !== null) {
        // this.$refs.searchCompanyName.ej2Instances.text = itemData.legalName;
          this.data.address = itemData.address ? itemData.address : '' || '';
          this.data.addressLine2 = itemData.addressLine2 ? itemData.addressLine2 : '' || '';
          this.data.cityName = itemData.cityName || '';
          this.companyProvince = itemData.provinceName || 0;
          this.data.countryName = itemData.countryName || 0;
          this.data.source = itemData.source || 0;
          this.data.sourceCompanyId = itemData.sourceCompanyId || 0;
          this.data.phoneNumber = itemData.phoneNumber || 0;
          this.data.faxNumber = itemData.faxNumber || 0;
          // this.companyId = itemData.companyId || 0;
          this.data.postalCode = itemData.postalCode || '';
          this.data.legalName = itemData.legalName || itemData.text || '';
        } else {
          this.data.cityName = '';
          this.data.address = '';
          this.data.addressLine2 = '';
          this.data.legalName = '';
          this.data.postalCode = '';
        }
      }
    },
    async companyData() {
      try {
        if (
          this.data.address !== null
          && this.data.address !== ''
          && (this.data.legalName === null || this.data.legalName === '')
        ) {
          this.isCompanyValid = false;
        }
        if (this.isCompanyValid) {
          this.data.provinceName = this.$refs.companyProvince.ej2Instances.text;
          this.data.countryName = this.$refs.companyCountry.ej2Instances.text;
          this.data.username = this.$store.getters.loggedUser
            ? this.$store.getters.loggedUser.email
            : this.userProfilesData.userName;
          // this.$store.getters.confirmedUser.userName;
          this.data.userId = this.userProfileId; // this.$store.getters.confirmedUser.userId;
          const {
            legalName,
            phoneNumber,
            faxNumber,
            address,
            addressLine2,
            cityName,
            postalCode,
            provinceName,
            countryName,
            username,
            source,
            sourceCompanyId,
            userId,
          } = this.data;
          await this.$store.dispatch(COMPANY_DATA, {
            legalName,
            phoneNumber,
            faxNumber,
            address,
            addressLine2,
            cityName,
            postalCode,
            provinceName,
            countryName,
            username,
            source,
            sourceCompanyId,
            userId,
          });
        } else {
          this.$parent.$parent.notificationToasts.push({
            title: 'Error!',
            content:
              'If company address existing, then Company Name is required.',
            cssClass: 'e-toast-danger',
            timeOut: 5000,
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
    async getComAddresses() {
      try {
        const melissaAddress1 = this.comMelissaAddress1;
        const melissaCountry = this.comMelissaCountry;
        await this.$store.dispatch(GET_MELISSA_ADDRESSES, {
          melissaAddress1,
          melissaCountry,
        });
        this.comAdressAutocompleteData = this.$store.getters.melissaAddresses;
      } catch (err) {
        console.error(err);
      }
    },
    onComAddressAutocompleteFiltering(e) {
      e.preventDefaultAction = true;
      if (
        e.text.length >= this.$refs.comAdressAutocomplete.ej2Instances.minLength
      ) {
        this.$refs.comAdressAutocomplete.ej2Instances.showSpinner();
        this.comMelissaAddress1 = e.text;
        if (
          this.$refs.companyCountry.ej2Instances.value !== null
          && this.$refs.companyCountry.ej2Instances.value !== ''
        ) {
          this.comMelissaCountry = this.$refs.companyCountry.ej2Instances.value;
        }
        this.comMelissaLocality = null;
        this.comMelissaAdministrativearea = null;
        const melissaAddress1 = this.comMelissaAddress1;
        const melissaCountry = this.comMelissaCountry;
        this.$store
          .dispatch(GET_MELISSA_ADDRESSES, {
            melissaAddress1,
            melissaCountry,
          })
          .then(() => {
            e.updateData(this.$store.getters.melissaAddresses);
          });
      }
    },
    onComAddressSelection(e) {
      const { itemData } = e;
      if (itemData.Address) {
        this.data.address = itemData.Address.Address || '';
        this.data.cityName = itemData.Address.SubAdministrativeArea
          || itemData.Address.Locality
          || '';
        this.data.provinceName = itemData.Address.AdministrativeArea || '';
        if (itemData.Address.ISO3166_2 === 'CA') {
          this.data.countryName = this.comMelissaCountryName;
        } else if (itemData.Address.ISO3166_2 === 'US') {
          this.data.countryName = 'United States';
        } else {
          this.data.countryName = this.comMelissaCountryName;
        }
        this.data.postalCode = itemData.Address.PostalCode || '';
        const checkAddress2 = (
          this.data.cityName
          + this.data.provinceName
          + this.data.postalCode
        ).replace(/ /g, '');
        const address2 = itemData.Address.Address2.replace(/ /g, '');
        if (address2.toLowerCase() === checkAddress2.toLowerCase()) this.data.addressLine2 = '';
        else this.data.addressLine2 = itemData.Address.Address2 || '';
        if (this.data.provinceName !== '') {
          this.province.every((r) => {
            if (r.provinceCode === this.data.provinceName) {
              this.companyProvince = r.provinceName;
              return true;
            }
            return true;
          });
        }
      } else {
        this.data.address = itemData['Address.Address'];
      }
    },
  },
};
</script>
